<template>
    <span>
        <criarlembretemedicacao></criarlembretemedicacao>
    </span>
</template>

<script>
import Criarlembretemedicacao from '@/components/Criar-Lembrete-Medicacao';

export default {
    name: 'cadcriarlembretemedicacao',
    components: {
        Criarlembretemedicacao
    }
};
</script>